import $ from 'jquery';

$(function () {

    // Get page elements
    const $wrapper = $('.panel-slides-wrapper');
    const $panels = $wrapper.children();
    const $dotsWrap = $('.js-panel-dots');

    // Only display if there are more than 2 sections present
    if ($panels.length > 2) {

        // Dynamically add index to slides and dots based on sections
        $panels.each(function (index) {
            $(this).attr('data-index', index);
            $dotsWrap.append(`<button class="panel-dot" data-index="${index}" aria-label="Jump to section ${index}"></button>`);
        });

        // And scroll to event handler
        $('.panel-dot').on('click', function () {

            // Change active classes
            $('.panel-dot.active').removeClass('active');
            $(this).addClass('active');

            // Get index and scroll to slide
            const index = parseInt($(this).attr('data-index'));
            const slide = $wrapper.children().get(index);
            window.scrollTo({top: $(slide).offset().top, behavior: 'smooth'});

        });

        // Setup intersection observer to watch for active dot
        const io = new IntersectionObserver((entries, observer) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    const index = entry.target.dataset.index;
                    $('.panel-dot.active').removeClass('active');
                    $(`.panel-dot[data-index="${index}"]`).addClass('active');
                }
            })
        }, {
            root: null,
            rootMargin: '0px',
            threshold: 1.0
        });
        document.querySelectorAll('.panel-slides-wrapper > *').forEach(elem => io.observe(elem));

    }


});